<template>
    <section>
        <sy-baselist
                hideAdd
                hideOperate
                listUrl="server/system/System.ashx?cmd=GetSysInfo"
        >
            <el-table-column prop="name" label="名称" width="250" sortable>
            </el-table-column>
            <el-table-column prop="value" label="状态" width="150" sortable>
            </el-table-column>
        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {

            }
        },
        methods:{

        },
        created(){

        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/system/SystemInfo.vue